export interface DashboardNewCardConfig {
  key: string
  label: string
  endpoint: string
  route: string
  svgIcon: string
  faIcon?: string
  iconColor: string
  showForAdmin?: boolean
}

export const NEW_DASHBOARD_CARDS: DashboardNewCardConfig[] = [
  {
    key: 'listingErrors',
    label: 'Listing Errors',
    endpoint: 'ListingErrors',
    route: 'listing-errors',
    svgIcon: 'triangle',
    faIcon: 'fa-triangle-exclamation',
    iconColor: 'danger',
  },
  {
    key: 'notYetListed',
    label: 'Not Yet Listed',
    endpoint: 'NotYetListed',
    route: 'not-yet-listed',
    svgIcon: 'information-5',
    iconColor: 'warning',
  },
  {
    key: 'linkErrors',
    label: 'Link Errors',
    endpoint: 'linkErrors',
    route: 'link-errors',
    svgIcon: 'disconnect',
    faIcon: 'fa-link-slash',
    iconColor: 'danger',
  },
  {
    key: 'priceChanges',
    label: 'Price Changes',
    endpoint: 'PriceChanges',
    route: 'price-changes',
    svgIcon: 'chart-line-up-2',
    iconColor: 'primary',
  },
  {
    key: 'priceMismatches',
    label: 'Price Mismatches',
    endpoint: 'PriceMismatches',
    route: 'price-mismatches',
    svgIcon: 'arrow-right-left',
    iconColor: 'danger',
  },
  {
    key: 'ratingChanges',
    label: 'Rating Changes',
    endpoint: 'RatingChanges',
    route: 'rating-changes',
    svgIcon: 'star',
    iconColor: 'warning',
  },
  {
    key: 'buyboxOwnerChanges',
    label: 'Buybox Owner Changes',
    endpoint: 'BuyboxOwnerChanges',
    route: 'buybox-owner-changes',
    svgIcon: 'verify',
    iconColor: 'success',
  },
  {
    key: 'fulfillmentChannelChanges',
    label: 'Amazon Fulfillment Changes',
    endpoint: 'FulfillmentChannelChanges',
    route: 'fulfillment-channel-changes',
    svgIcon: 'truck',
    faIcon: 'fa-truck-fast',
    iconColor: 'info',
  },
  {
    key: 'buyboxSuppressed',
    label: 'BuyBox Suppressed',
    endpoint: 'BuyboxSuppressed',
    route: 'buybox-suppressed',
    svgIcon: 'shield-slash',
    iconColor: 'danger',
  },
  {
    key: 'categoryChanges',
    label: 'Category Changes',
    endpoint: 'CategoryChanges',
    route: 'category-changes',
    svgIcon: 'grid-2',
    iconColor: 'info',
  },
  {
    key: 'salesRankChanges',
    label: 'Ranking Changes',
    endpoint: 'SalesRankChanges',
    route: 'sales-rank-changes',
    svgIcon: 'medal-star',
    iconColor: 'warning',
  },
  {
    key: 'channelInventoryFeedStatusChanges',
    label: 'Channel Inventory Feed Status Changes',
    endpoint: 'ChannelInventoryFeedStatusChanges',
    route: 'channel-inventory-feed-status-changes',
    svgIcon: 'switch',
    iconColor: 'primary',
    showForAdmin: true,
  },
  {
    key: 'fbaFbmAdjustedProducts',
    label: 'SFP Percentage for FBA/FBM-Adjusted Products',
    endpoint: 'FbaFbmAdjustedProducts',
    route: 'fba-fbm-adjusted-products',
    svgIcon: 'price-tag',
    iconColor: 'success',
    showForAdmin: true,
  },
]
